import {HTMLAttributes} from 'react';
import {Typography} from '@/components/Typography';
import {getCompareAvgLevel, getCompareAvgText} from '@/map/utils';
import {palette} from '@/styles/palette';

interface IProps extends HTMLAttributes<HTMLSpanElement> {
  total?: number;
  avg?: number;
}

const COLOR = {
  2: palette.red100,
  1: '#F17F1F',
  0: '#DC9D15',
  [-1]: palette.green400,
  [-2]: palette.blue100,
};

export const CompareAvgText = ({total, avg, ...props}: IProps) => {
  if (!total || !avg) {
    return null;
  }

  const level = getCompareAvgLevel(total, avg);

  return (
    <Typography fontWeight={700} {...props} color={COLOR[level]}>
      {getCompareAvgText(level)}
    </Typography>
  );
};
